import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PostService } from "../GenericServices/genericService";
import Swal from "sweetalert2";
import { Path, resources_EN } from "../GenericServices/componentUtils";

const Login = ({ setCurrentPage, login }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    loginAPI();
    // e.preventDefault();
    // if (login(username, password)) {
    //   // setCurrentPage("admin");
    //   navigate("/admin");
    // } else {
    //   setError("Invalid username or password");
    // }
  };

  /* Login API */
  const loginAPI = () => {
    const data = {
      username: username,
      password: password,
    };
    const url = "myNewAPI/login.php";
    PostService(url, data, modal);
  };

  /* Error or Success Modal */
  const modal = (icon, title, message, response = "") => {
    Swal.fire({
      title: title,
      icon: icon,
      text: message,
    }).then((resp) => {
      if (resp.isConfirmed && icon === resources_EN.success) {
        localStorage.setItem("userId", response.data.user.user_id);
        navigate(Path.admin);
      }
    });
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
        <h2 className="text-2xl font-bold text-center mb-6">Admin Login</h2>
        <form>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
          {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
          <button
            onClick={handleSubmit}
            type="button"
            className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700"
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
